// src/firebase.ts
import { initializeApp, getApps } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyDSotLV6rAxHSy4jXQ9GzxDBDJJA2-Yp7A",
  authDomain: "employher---production.firebaseapp.com",
  projectId: "employher---production",
  appId: ":866760642760:web:ead43da2f812608322d5fd",
};

if (!getApps().length) {
  initializeApp(firebaseConfig);
}
